module.exports = __webpack_public_path__ + "img/mailbox.17bc6162.png";